module.exports = __webpack_public_path__ + "static/img/logo.d743fad9.png";